<div class="page-content-wrapper">
    <app-sidebar-layout [showMenuToggle]="true" [fillHeight]="true">
        <section class="card-style-sec risk-sec">
            <div class="risk-header" *ngIf="riskAssessment">
                <div class="risk-title-row">
                    <div class="risk-title-left">
                        <span class="back-btn cursor-pointer" (click)="goToRiskRegister()">
                            <span class="material-symbols-outlined purple-text">chevron_left</span>
                        </span>
                        <div class="card-details">
                            <h4 class="card-title mb-0">{{riskAssessment?.name}}</h4>
                        </div>
                    </div>

                    <div class="risk-meta-strip">
                        <div class="meta-item">
                            <span class="meta-label">{{'Status' | translate}}</span>
                            <span class="meta-value">
                                <ng-container [ngSwitch]="$safeNavigationMigration(riskAssessment?.assessmentStatus)">
                                    <ng-container *ngSwitchCase="assessmentStatusEnum.Draft">{{'Draft' | translate}}</ng-container>
                                    <ng-container *ngSwitchCase="assessmentStatusEnum.InReview">{{'In Review' | translate}}</ng-container>
                                    <ng-container *ngSwitchCase="assessmentStatusEnum.Approved">{{'Approved' | translate}}</ng-container>
                                    <ng-container *ngSwitchCase="assessmentStatusEnum.Rejected">{{'Rejected' | translate}}</ng-container>
                                    <ng-container *ngSwitchDefault>{{ $safeNavigationMigration(riskAssessment?.assessmentStatus) | nullDisplay }}</ng-container>
                                </ng-container>
                            </span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-label">{{'Time Period' | translate}}</span>
                            <span class="meta-value">{{$safeNavigationMigration(riskAssessment?.periodStart) | dateFormat}} - {{$safeNavigationMigration(riskAssessment?.periodEnd) | dateFormat}}</span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-label">{{'Jurisdiction' | translate}}</span>
                            <span class="meta-value">{{jurisdictionName}}</span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-label">{{'OEL Type' | translate}}</span>
                            <span class="meta-value">{{oelTypeName}}</span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-label">{{'Apply Shift Correction' | translate}}</span>
                            <span class="meta-value">{{riskAssessment?.applyShiftCorrection ? ('Yes' | translate) : ('No' | translate)}}</span>
                        </div>
                        <!-- G19/DASH-2977 (FE-3, AC8): the non-detect handling method the displayed
                             statistics were computed under (snapshotted), not the current jurisdiction setting. -->
                        <div class="meta-item" *ngIf="snapshotCensoredDataMethodLabel"
                            [matTooltip]="'The statistics shown were computed under this non-detect handling method.' | translate">
                            <span class="meta-label">{{'Non-Detect Handling' | translate}}</span>
                            <span class="meta-value">{{ snapshotCensoredDataMethodLabel | translate }}</span>
                        </div>
                        <!-- G19 (DASH-2976): sample-scope summary. -->
                        <div class="meta-item" *ngFor="let row of sampleFilterSummaryRows; trackBy: trackByIndex">
                            <span class="meta-label">{{ row.label }}</span>
                            <span class="meta-value">{{ row.value }}</span>
                        </div>
                    </div>
                </div>

                <div class="risk-subheader-row">
                    <div class="top-tabs">
                        <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onTabChange($event)">
                            <mat-tab *ngFor="let category of hazardCategoryTabs; trackBy: trackByIndex"
                                label="{{ hazardCategoryLabels[category] | translate }}"></mat-tab>
                        </mat-tab-group>
                    </div>

                    <div class="search-input-div d-flex">
                        <div class="input-group">
                            <div class="input-field">
                                <input type="search" #search (keyup)="searchGrid(search)" class="search-input mb-0"
                                    placeholder="{{'Search Risk Assessments' | translate}}">
                            </div>
                            <button type="submit" class="input-group-addon">
                                <label class="label-icon" for="search">
                                    <i class="material-icons mb-0">search</i>
                                </label>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="risk-toolbar-row" *ngIf="registerContentVisible">
                    <div class="toolbar-left d-flex">
                        <div class="risk-view-mode-selector" *ngIf="activeProfile.usesExposureAssessment">
                            <mat-radio-group
                                [ngModel]="viewMode"
                                (change)="onViewModeChange($event)"
                                class="view-mode-radio-group"
                                [attr.aria-label]="'Risk view mode' | translate">
                                <mat-radio-button [value]="viewModeEnum.ExposureBand">
                                    {{'Exposure Band' | translate}}
                                </mat-radio-button>
                                <mat-radio-button [value]="viewModeEnum.Likelihood">
                                    {{'Likelihood' | translate}}
                                </mat-radio-button>
                                <mat-radio-button [value]="viewModeEnum.HealthRisk">
                                    {{'Health Risk' | translate}}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div class="risk-legends-row"
                            *ngIf="(showLikelihoodLegend && likelihoodLegendItems.length) || (showRiskLevelLegend && riskLevelLegendItems.length) || showComplianceLegend">
                            <app-risk-config-legend *ngIf="showLikelihoodLegend"
                                [label]="'Likelihood Levels/Exposure bands'"
                                [items]="likelihoodLegendItems"></app-risk-config-legend>
                            <app-risk-config-legend *ngIf="showRiskLevelLegend"
                                [label]="'Health Risk Levels'"
                                [items]="riskLevelLegendItems"></app-risk-config-legend>
                            <app-risk-config-legend *ngIf="showComplianceLegend"
                                [label]="'EN 689 Compliance'"
                                [items]="complianceLegendItems"></app-risk-config-legend>
                        </div>
                    </div>

                    <div class="toolbar-right d-flex align-items-center">
                        <button type="button" class="btn toolbar-btn card-slot-trigger" #groupByButton [matMenuTriggerFor]="groupByMenu" (menuOpened)="matchGroupByMenuWidth(groupByButton)"
                            [matTooltip]="'Group by' | translate" [matTooltipDisabled]="!compactToolbar">
                            <span class="material-symbols-outlined card-slot-icon">account_tree</span>
                            @if (!compactToolbar) {
                                {{ 'Group by' | translate }}:
                            }
                            @for (option of groupByOptions; track option.value) {
                                @if (option.value === groupBy) {
                                    {{ option.label | translate }}
                                }
                            }
                        </button>
                        <mat-menu #groupByMenu="matMenu" xPosition="before" class="row-action-menu--compact group-by-menu">
                            @for (option of groupByOptions; track option.value) {
                                <button mat-menu-item (click)="onGroupByChange(option.value)">
                                    <span class="group-by-option" [class.selected]="option.value === groupBy">{{ option.label | translate }}</span>
                                </button>
                            }
                        </mat-menu>
                        <button type="button" class="btn toolbar-btn card-slot-trigger" (click)="openCardSlotPicker()"
                            [matTooltip]="'Card Customization' | translate" [matTooltipDisabled]="!compactToolbar">
                            <span class="material-symbols-outlined card-slot-icon">dashboard_customize</span>
                            @if (!compactToolbar) {
                                {{ 'Card Customization' | translate }}
                            }
                        </button>
                        @if (canEditRegisters) {
                            <mat-slide-toggle class="bulk-toggle" color="primary" [class.compact]="compactToolbar"
                                [checked]="bulkMode" (change)="goBulk()"
                                [disabled]="isParentAssessmentApproved"
                                [matTooltip]="isParentAssessmentApproved ? ('This assessment is approved, so its registers are read-only. Un-approve the assessment to edit them.' | translate) : compactToolbar ? ('Bulk Edit' | translate) : ''">
                                @if (!compactToolbar) {
                                    {{'Bulk Edit' | translate}}
                                }
                            </mat-slide-toggle>
                        }
                        <button class="btn toolbar-btn export-btn" (click)="openRiskRegisterReportDialog()"
                            [matTooltip]="'Export' | translate" [matTooltipDisabled]="!compactToolbar">
                            <span class="material-symbols-outlined export-icon">download</span>
                            @if (!compactToolbar) {
                                {{'Export' | translate}}
                            }
                        </button>
                        <div class="sort-field table-view-selector" [class.view-controls-disabled]="bulkMode">
                            <app-table-view-selector [objectId]="viewObjectId" [gridId]="gridId"
                                [defaultViewId]="defaultGridViewId" [selectedViewId]="currentSelectedViewId"
                                [refreshViews$]="refreshViews$" [fallbackToFirstView]="false" [isTemporaryView]="hasUnsavedViewChanges"
                                (addView)="onAddView($event)" (viewSelected)="onViewSelected($event.view)"
                                (viewDeleted)="onViewDeleted($event)">
                            </app-table-view-selector>
                        </div>
                        <div class="sort-field grid-settings">
                            <button type="button" class="btn toolbar-btn filters-btn" [matTooltip]="gridSettingsTooltip || ('Grid settings' | translate)"
                                matTooltipClass="filter-summary-tooltip"
                                [disabled]="bulkMode || isLoading" (click)="openViewFlyout()">
                                <img src="assets/images/grid-settings.svg" alt="grid settings" class="grid-settings-icon" />
                                @if (appliedFilterTags.length) {
                                    <span class="filters-badge">{{ appliedFilterTags.length }}</span>
                                }
                            </button>
                        </div>
                    </div>
                </div>

                <div class="assessment-locked-banner" *ngIf="isParentAssessmentApproved">
                    <span class="material-icons">lock</span>
                    <span>{{'This assessment is approved, so its registers are read-only. Un-approve the assessment to edit them.' | translate}}</span>
                </div>
            </div>

            <div class="generation-status-panel" *ngIf="isGenerating">
                <app-rings-loader></app-rings-loader>
                <h5 class="generation-status-title">{{'Generating risk registers…' | translate}}</h5>
                <p class="generation-status-text">
                    {{'This can take a few minutes for a large assessment. You can safely navigate away — generation continues in the background.' | translate}}
                </p>
            </div>

            <div class="generation-status-panel generation-status-timeout" *ngIf="generationTimedOut">
                <span class="material-icons generation-status-icon">hourglass_empty</span>
                <h5 class="generation-status-title">{{'Still generating risk registers' | translate}}</h5>
                <p class="generation-status-text">
                    {{'Generation is taking longer than expected. It may still be running in the background.' | translate}}
                </p>
                <button class="btn small-btn mw-80" (click)="keepCheckingGeneration()">{{'Keep checking' | translate}}</button>
            </div>

            <div class="generation-status-panel generation-status-failed" *ngIf="isGenerationFailed">
                <span class="material-icons generation-status-icon">error_outline</span>
                <h5 class="generation-status-title">{{'Risk register generation failed' | translate}}</h5>
                <p class="generation-status-text">
                    {{ generationError || ('Risk register generation could not be completed for this assessment.' | translate) }}
                </p>
                <button class="btn small-btn mw-80" (click)="retryGeneration()">{{'Delete and recreate' | translate}}</button>
            </div>

            <div class="container-fluid custom-container" *ngIf="registerContentVisible">
                <div class="white-box">
                    <div class="card-inner-main-div mb-0">
                        <div class="tableColStyle custom-theme-table">

                            <div *ngIf="isLoading || bulkLoading || isExporting" class="text-center py-3">
                                <app-rings-loader></app-rings-loader>
                                <p *ngIf="bulkUpdatingCount" class="mt-2 mb-0">{{ 'Updating {{count}} risk register(s)…' | translate: {count: bulkUpdatingCount} }}</p>
                            </div>

                            <ng-template #groupHeader let-element>
                                <ng-template #groupHeaderContent>
                                    @if (element.collapsible) {
                                        <span class="material-symbols-outlined group-toggle-icon">{{ element.collapsed ? 'chevron_right' : 'expand_more' }}</span>
                                    }
                                    <span class="group-header-text">
                                        <span class="group-header-caption">{{ 'Organization Level' | translate }}</span>
                                        <span class="group-header-line">
                                            <span class="group-header-label" [title]="element.title">{{ element.name }}</span>
                                            <span class="group-header-count">({{ element.segCount }})</span>
                                        </span>
                                    </span>
                                </ng-template>
                                @if (element.collapsible) {
                                    <button type="button" class="group-header-cell group-toggle" [class.in-code-column]="groupHeaderInCodeColumn"
                                        (click)="toggleGroup(element.groupKey)"
                                        [matTooltip]="(element.collapsed ? 'Expand' : 'Collapse') | translate">
                                        <ng-container *ngTemplateOutlet="groupHeaderContent"></ng-container>
                                    </button>
                                } @else {
                                    <div class="group-header-cell" [class.in-code-column]="groupHeaderInCodeColumn">
                                        <ng-container *ngTemplateOutlet="groupHeaderContent"></ng-container>
                                    </div>
                                }
                            </ng-template>

                            <div class="register-grid-box" [class.is-empty]="!isLoading && !displayRows.length">
                            @for (layout of [rowLayoutKey()]; track layout) {
                                <cdk-virtual-scroll-viewport class="custom-scrollbar matrix-viewport table-shadow"
                                    [class.is-empty]="!isLoading && !displayRows.length"
                                    [itemSize]="rowHeightPx" [minBufferPx]="rowHeightPx * 6" [maxBufferPx]="rowHeightPx * 12">
                                    <table mat-table class="table" [dataSource]="displayRows" [class.no-rows]="!displayRows.length"
                                        [class.psychological-table]="activeProfile.usesHealthRiskScore"
                                        matSort matSortDisableClear
                                        [matSortActive]="matrixSort?.active ?? ''" [matSortDirection]="matrixSort?.direction ?? ''"
                                        (matSortChange)="onMatrixSortChange($event)"
                                        cdkDropList cdkDropListOrientation="horizontal"
                                        [cdkDropListDisabled]="!columnReorderEnabled"
                                        (cdkDropListDropped)="onAgentColumnDrop($event)">

                                        <ng-container matColumnDef="segCode" [sticky]="frozenColumnNames.has('segCode')">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header="segCode" class="left-aligned col-seg-code">{{'SEG Code' | translate}}
                                            </th>
                                            <td mat-cell class="left-aligned seg-code-cell col-seg-code" *matCellDef="let element"
                                                [class.group-header-host]="element.kind === rowKind.GroupHeader && groupHeaderInCodeColumn">
                                                @if (element.kind === rowKind.Seg) {
                                                    <span class="seg-code-text" [title]="element.seg.segCode ?? ''">{{ element.seg.segCode ?? '-' }}</span>
                                                } @else if (element.kind === rowKind.GroupHeader && groupHeaderInCodeColumn) {
                                                    <ng-container *ngTemplateOutlet="groupHeader; context: { $implicit: element }"></ng-container>
                                                }
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef></td>
                                        </ng-container>

                                        <ng-container matColumnDef="segName" [sticky]="frozenColumnNames.has('segName')">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header="segName" class="left-aligned col-seg-name">{{'SEG' | translate}}
                                            </th>
                                            <td mat-cell class="left-aligned col-seg-name"
                                                *matCellDef="let element" [class.cursor-pointer]="element.kind === rowKind.Seg"
                                                [class.group-header-host]="element.kind === rowKind.GroupHeader && !groupHeaderInCodeColumn"
                                                [title]="element.kind === rowKind.Seg ? element.seg.segName : ''">
                                                @if (element.kind === rowKind.Seg) {
                                                    <div *ngIf="bulkMode; else header" class="d-flex">
                                                        <mat-checkbox class="d-flex" (click)="toggleRow(element.seg)"
                                                            [disabled]="bulkLoading" [(ngModel)]="element.seg.selected"> </mat-checkbox>
                                                        <div class="my-auto">
                                                            <ng-container *ngTemplateOutlet="header"></ng-container>
                                                        </div>
                                                    </div>
                                                    <ng-template #header><span class="seg-name-text">{{element.seg.segName}}</span></ng-template>
                                                } @else if (element.kind === rowKind.GroupHeader && !groupHeaderInCodeColumn) {
                                                    <ng-container *ngTemplateOutlet="groupHeader; context: { $implicit: element }"></ng-container>
                                                }
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef class="left-aligned column-delete-label"
                                                [title]="'Delete all registers for an agent' | translate">
                                                {{'Delete all registers for an agent' | translate}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="numberOfWorkers" [sticky]="frozenColumnNames.has('numberOfWorkers')">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header="numberOfWorkers" class="col-headcount">{{'No of Employees' | translate}}</th>
                                            <td mat-cell *matCellDef="let element">
                                                @if (element.kind === rowKind.Seg) {
                                                    {{ element.numberOfWorkers ?? '-' }}
                                                }
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef></td>
                                        </ng-container>

                                        <ng-container matColumnDef="numberOfContractors" [sticky]="frozenColumnNames.has('numberOfContractors')">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header="numberOfContractors" class="col-headcount">{{'No of Contractors' | translate}}</th>
                                            <td mat-cell *matCellDef="let element">
                                                @if (element.kind === rowKind.Seg) {
                                                    {{ element.numberOfContractors ?? '-' }}
                                                }
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef></td>
                                        </ng-container>

                                        <ng-container matColumnDef="orgLevelName" [sticky]="frozenColumnNames.has('orgLevelName')">
                                            <th mat-header-cell *matHeaderCellDef class="left-aligned col-org-level">{{'Organization Level' | translate}}</th>
                                            <td mat-cell class="left-aligned col-org-level" *matCellDef="let element" [title]="element.seg?.orgLevelTitle ?? ''">
                                                @if (element.kind === rowKind.Seg) {
                                                    <span class="org-level-text">{{ element.seg.orgLevelName ?? '-' }}</span>
                                                }
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef></td>
                                        </ng-container>

                                        <ng-container *ngFor="let value of extraColumns; let index = index; trackBy: trackByAgentId">
                                            <ng-container [matColumnDef]="$safeNavigationMigration(value?.headerName)">
                                                <th mat-header-cell *matHeaderCellDef class="col-agent"
                                                    [mat-sort-header]="value.agentId"
                                                    cdkDrag cdkDragLockAxis="x" [cdkDragDisabled]="!columnReorderEnabled">
                                                    <div class="agent-header">
                                                        @if (columnReorderEnabled) {
                                                            <span cdkDragHandle
                                                                class="material-icons column-drag-handle"
                                                                [matTooltip]="dragHandleTooltip"
                                                                (click)="$event.stopPropagation()">drag_indicator</span>
                                                        }
                                                        <div *ngIf="bulkMode; else header" class="d-flex">
                                                            <mat-checkbox class="d-flex" (click)="$event.stopPropagation(); toggleColumn(value, index)"
                                                                [disabled]="bulkLoading" [(ngModel)]="value.selected"> </mat-checkbox>
                                                            <ng-container *ngTemplateOutlet="header"></ng-container>
                                                        </div>
                                                    </div>
                                                    <ng-template #header>
                                                        <div class="agent-header-text" [title]="value?.agentName ?? ''">
                                                            <div class="agent-name">{{value?.agentName}} </div>
                                                            <div class="agent-consequence" *ngIf="activeProfile.usesExposureAssessment">{{ consequenceRatingLabel }}
                                                                {{ $safeNavigationMigration(value?.consequenceRating) | nullDisplay }}</div>
                                                        </div>
                                                    </ng-template>
                                                </th>
                                                <td mat-footer-cell *matFooterCellDef class="column-delete-footer">
                                                    <i *objectHasPermission="permissionObject; action: deleteAction"
                                                        class="fa fa-trash delete-icon"
                                                        [class.disabled-icon]="columnDeleteDisabled"
                                                        [class.cursor-pointer]="!columnDeleteDisabled"
                                                        [matTooltip]="columnDeleteTooltip"
                                                        (click)="!columnDeleteDisabled && deleteColumn(value)"></i>
                                                </td>
                                            </ng-container>
                                        </ng-container>

                                        <ng-container matColumnDef="agentWindow">
                                            <ng-container *matCellDef="let element">
                                                <td mat-cell [attr.colspan]="renderedColumns().start || null"
                                                    [class.off-window]="!renderedColumns().start"></td>
                                                @for (slot of agentSlots(); track slot) {
                                                    @let register = element.seg?.registers[renderedColumns().start + slot];
                                                    <td class="col-agent"
                                                        [class.cursor-pointer]="!!register"
                                                        (click)="register && openRiskAssessmentDetails(register.id)">
                                                        @if (register) {
                                                            <app-risk-register-matrix-cell
                                                                [register]="register"
                                                                [selected]="!!register.selected"
                                                                [bulkMode]="bulkMode"
                                                                [profile]="activeProfile"
                                                                [isParentAssessmentApproved]="isParentAssessmentApproved"
                                                                [canEdit]="canEditRegisters"
                                                                [bulkLoading]="bulkLoading"
                                                                (selectedChange)="toggleSelection(element.seg, renderedColumns().start + slot, $event)"
                                                                (edit)="openHealthRiskDialog(register)">
                                                            </app-risk-register-matrix-cell>
                                                        }
                                                    </td>
                                                }
                                                <td mat-cell [attr.colspan]="extraColumns.length - renderedColumns().end || null"
                                                    [class.off-window]="extraColumns.length === renderedColumns().end"></td>
                                            </ng-container>
                                        </ng-container>

                                        <ng-container matColumnDef="action">
                                            <th class="action-column col-action" mat-header-cell *matHeaderCellDef>{{'Action' | translate}}</th>
                                            <td class="action-column col-action bordered-cell" mat-cell
                                                *matCellDef="let riskAssessment">
                                                @if (riskAssessment.kind === rowKind.Seg) {
                                                    <i *objectHasPermission="permissionObject; action: deleteAction"
                                                        (click)="deleteRiskRegister(riskAssessment.seg)"
                                                        class="fa fa-trash delete-icon"
                                                        [class.disabled-icon]="isParentAssessmentApproved || bulkLoading"
                                                        [class.cursor-pointer]="!isParentAssessmentApproved && !bulkLoading"
                                                        [matTooltip]="rowDeleteTooltip"></i>
                                                }
                                            </td>
                                            <td class="action-column" mat-footer-cell *matFooterCellDef></td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                        <tr mat-row *matRowDef="let row; columns: rowColumns();"
                                            [class.even-row]="row.even"
                                            [class.group-header-row]="row.kind === rowKind.GroupHeader"
                                            [style.height.px]="rowHeightPx"></tr>
                                        <tr mat-footer-row class="column-delete-footer-row"
                                            *matFooterRowDef="displayedColumns; sticky: true"></tr>
                                    </table>
                                </cdk-virtual-scroll-viewport>
                            }
                            @if (!isLoading && !displayRows.length) {
                                <div class="register-empty-state">
                                    @if (appliedFilterTags.length || currentSearchQuery) {
                                        <h5 class="register-empty-title">{{ 'No registers match the filters' | translate }}</h5>
                                        <p class="register-empty-text">{{ 'Try changing or removing a filter, or clear the search.' | translate }}</p>
                                        <button type="button" class="btn toolbar-btn export-btn register-reset-btn" (click)="resetFiltersAndSearch()">{{ 'Reset Filters' | translate }}</button>
                                    } @else {
                                        <h5 class="register-empty-title">{{ 'No risk registers in this assessment yet' | translate }}</h5>
                                        <p class="register-empty-text">{{ 'They appear here once SEGs and agents are assessed.' | translate }}</p>
                                    }
                                </div>
                            }
                            </div>
                            <div *ngIf="isLoadingNextPage" class="text-center py-2">
                                <app-rings-loader></app-rings-loader>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="clearfix"></div>
            </div>
        </section>

        <div class="bulk-selection-container" *ngIf="bulkMode">
            <div class="count">{{ '{{count}} item(s) selected' | translate: {count: selectedCount} }}</div>
            <div (click)="toggleSelectAll(!isAllSelected)">{{ isAllSelected ? ('Clear All' | translate) : ('Select All' | translate) }}</div>
            <div class="bulk-dropdown" [class.disabled]="!selectedCount || bulkLoading" (click)="openDialog(dialogTypeEnum.AssessmentStatus)">{{'Change Status' | translate}}</div>
            <div *ngIf="activeProfile.allowsRiskScoring" class="bulk-dropdown" [class.disabled]="!selectedCount || bulkLoading" (click)="openDialog(dialogTypeEnum.HealthRiskScore)">{{'Risk Scoring' | translate}}</div>
            <div *ngIf="activeProfile.usesExposureAssessment" class="bulk-dropdown" [class.disabled]="!selectedCount || bulkLoading" (click)="openDialog(dialogTypeEnum.MethodOfAssessment)">{{'Change Method Of Assessment' | translate}}</div>
            <div *ngIf="activeProfile.usesExposureAssessment" class="bulk-dropdown" [class.disabled]="!selectedCount || bulkLoading" (click)="openDialog(dialogTypeEnum.ConsequenceRating)">{{'Change Consequence Rating' | translate}}</div>
            <div class="bulk-dropdown" [class.disabled]="true" (click)="openDialog(dialogTypeEnum.RiskRegisterControls)">{{'Add Existing Controls' | translate}}</div>
        </div>
    </app-sidebar-layout>

    <div class="view-flyout-host" *ngIf="isViewFlyoutOpen">
        <app-grid-settings-flyout class="grid-settings-flyout"
            [gridViewColumns]="viewColumns" [title]="viewTitle" [selectedGridView]="selectedGridView"
            [gridId]="gridId" [showFiltersTab]="false" [showSortTab]="false"
            [canFreezeColumn]="freezableColumnNames" [extraTabs]="flyoutTabs"
            (close)="onViewFlyoutClose($event)" (columnsChanged)="onViewColumnsChanged($event)"
            (frozenColumnsChanged)="onViewFrozenColumnsChanged($event)">
        </app-grid-settings-flyout>
    </div>
</div>

<ng-template #quickFiltersTab>
    <div class="quick-filters-tab">
        @if (!filterRows.length) {
            <div class="no-active-filters-msg">{{ 'No filters currently active' | translate }}</div>
        }
        @for (row of filterRows; track row.def.key + row.filter.operator) {
            <div class="filter-row">
                @if (editingFilterKey === row.def.key) {
                    <div class="filter-header enum-filter">
                        <span class="filter-column">{{ row.def.label | translate }}&nbsp;</span>
                        <span class="filter-operator-label">
                            @if (row.def.kind === filterKind.Range) {
                                <mat-form-field appearance="fill" class="filter-operator-select">
                                    <mat-select class="filter-select" [ngModel]="row.filter.operator"
                                        (selectionChange)="onFilterOperatorChange(row, $event.value)">
                                        @for (operator of rangeOperators; track operator.value) {
                                            <mat-option [value]="operator.value">{{ operator.label | translate }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            } @else {
                                <span class="enum-operator-label">{{ 'is' | translate }}</span>
                            }
                        </span>
                    </div>
                    <app-filter-type [filter]="row.filter" [getFilteredOptions]="getFilterOptions"
                        (filterChange)="applyFilterRow(row)">
                    </app-filter-type>
                } @else {
                    <div class="filter-chip-display" [class.filter-off]="disabledFilterKeys.has(row.def.key)">
                        <button type="button" class="filter-chip-btn" [matMenuTriggerFor]="filterActionMenu">
                            {{ row.def.label | translate }}
                            <span class="operator-label">{{ filterSummaries[row.def.key]?.operator }}</span>
                            @if (filterSummaries[row.def.key]?.value) {
                                <span>{{ filterSummaries[row.def.key].value }}</span>
                            }
                            <i class="fa fa-chevron-down"></i>
                        </button>
                        <mat-slide-toggle class="filter-chip-switch" [checked]="!disabledFilterKeys.has(row.def.key)"
                            (change)="toggleFilterRow(row, $event.checked)"></mat-slide-toggle>
                        <mat-menu #filterActionMenu="matMenu">
                            <button mat-menu-item (click)="editFilterRow(row)">
                                <i class="fa fa-edit"></i> {{ 'Edit' | translate }}
                            </button>
                            <button mat-menu-item (click)="removeFilterRow(row)">
                                <i class="fa fa-trash"></i> {{ 'Delete' | translate }}
                            </button>
                        </mat-menu>
                    </div>
                }
            </div>
        }
        @if (availableFilterFields.length) {
            <button type="button" class="add-filter-btn" [matMenuTriggerFor]="addFilterMenu">
                <mat-icon>add</mat-icon>
                {{ 'Add Filter' | translate }}
            </button>
            <mat-menu #addFilterMenu="matMenu" class="filter-menu">
                <div class="filter-menu-content">
                    <div class="filter-menu-options">
                        @for (field of availableFilterFields; track field.key) {
                            <button mat-menu-item class="filter-menu-option" (click)="addFilterRow(field)">{{ field.label | translate }}</button>
                        }
                    </div>
                </div>
            </mat-menu>
        }
        @if (filterRows.length) {
            <hr />
            <button type="button" class="reset-filters-btn" (click)="resetFilters()">
                <img src="assets/images/repeat.svg" alt="" class="reset-filters-img" />
                {{ 'Reset Filters' | translate }}
            </button>
        }
    </div>
</ng-template>

<ng-template #agentsTab>
    <div class="agents-tab">
        <div class="agents-tab-order">
            <div class="agents-tab-section-title">
                <span class="material-symbols-outlined agents-tab-info-icon">info</span>
                {{'Agent order' | translate}}
            </div>
            <span class="agents-tab-note">{{'Drag agent headers in the grid to reorder them. The order is shared by everyone on this assessment.' | translate}}</span>
            <button *ngIf="canReorderColumns" type="button" class="btn agents-tab-reset"
                [disabled]="!hasCustomColumnOrder || isSavingColumnOrder"
                (click)="resetAgentColumnOrder()">{{'Reset order to A-Z for everyone' | translate}}</button>
        </div>
        <div class="agents-tab-section-title">{{'Visible agents' | translate}}</div>
        <app-search-input class="agents-tab-search" [placeholder]="'Search agents' | translate" [value]="agentSearch"
            (valueChange)="onAgentSearch($event)">
        </app-search-input>
        <div class="agents-tab-list">
            <div class="agents-tab-item agents-tab-all" *ngIf="!agentSearch">
                <span class="agents-tab-name">{{'All' | translate}}</span>
                <mat-slide-toggle [checked]="allAgentsVisible" (change)="toggleAllAgents($event.checked)"></mat-slide-toggle>
            </div>
            <div class="agents-tab-item" *ngFor="let agent of filteredAgentToggles; trackBy: trackByAgentId">
                <span class="agents-tab-name" [title]="agent.agentName">{{ agent.agentName }}</span>
                <mat-slide-toggle [checked]="agent.visible" (change)="onAgentToggle(agent.agentId, $event.checked)"></mat-slide-toggle>
            </div>
            <div class="agents-tab-empty" *ngIf="!filteredAgentToggles.length">{{'No agents match your search' | translate}}</div>
        </div>
    </div>
</ng-template>

<app-risk-register-details-popup
    [show]="showDetails"
    [id]="selectedRiskId"
    (hideRiskDetailEmit)="hideRiskDetailFn()"
    (updateGridEmit)="onRegisterDetailsSaved()"
    [riskLevels]="riskLevels"
    [jurisdictionId]="$safeNavigationMigration(riskAssessment?.jurisdictionId)"
    [parentAssessmentStatus]="$safeNavigationMigration(riskAssessment?.assessmentStatus)">
</app-risk-register-details-popup>

<ng-template #changeSelectionDialog>
    <h3 mat-dialog-title>{{ dialogTitle }}</h3>

    <mat-dialog-content>
        <mat-radio-group [ngModel]="selectedDialogValue" (ngModelChange)="onDialogValueChange($event)"
            [disabled]="singleRegisterLocked"
            *ngIf="dialogType !== dialogTypeEnum.RiskRegisterControls; else controlsTemplate">
            <mat-radio-button *ngFor="let option of dialogOptions; trackBy: trackById" [value]="option.id">
                {{ option.name | translate}}
            </mat-radio-button>
        </mat-radio-group>

        <p class="mt-3 mb-0" *ngIf="singleRegisterLocked">
            {{ (bulkMode ? approvedBulkHintText : approvedBlockedText) | translate }}
        </p>

        <div class="mt-4 mb-n4" *ngIf="!bulkMode && dialogType === dialogTypeEnum.HealthRiskScore">
            <span class="bold">{{'Approval Status' | translate}}</span>
            <mat-form-field appearance="fill" class="status-select ml-4">
                <mat-select [(value)]="selectedRegisterStatus" (selectionChange)="refreshDialogConfirmState()" panelClass="status-dropdown-panel"
                    placeholder="{{'Select Status' | translate}}">
                    <mat-select-trigger>
                        <span class="status-badge"
                            [ngStyle]="{'background-color': registerStatusColors[selectedRegisterStatus] || null}">
                            {{ riskRegisterAssessmentStatusEnum[selectedRegisterStatus] | translate }} 
                        </span>
                    </mat-select-trigger>

                    <mat-option class="status-dropdown-options" *ngFor="let status of allowedStatusList; trackBy: trackById"
                        [value]="status.id">
                        <span class="status-badge"
                            [ngStyle]="{'background-color': registerStatusColors[status.id] || null}">
                            {{ status.name | translate }}
                        </span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="mt-4 bulk-reason" *ngIf="dialogType === dialogTypeEnum.ConsequenceRating">
            <span class="bold">{{'Reason for Change' | translate}}<span class="red-text">*</span></span>
            <textarea
                matInput
                class="form-control mt-2"
                rows="3"
                [maxlength]="bulkCommentMaxLength"
                [placeholder]="'Enter reason for change...' | translate"
                [ngModel]="bulkComment"
                (ngModelChange)="onBulkCommentChange($event)"
                [ngModelOptions]="{standalone: true}"
                required>
            </textarea>
        </div>

        <ng-template #controlsTemplate>
            <mat-form-field appearance="outline" class="search-field w-100">
                <mat-icon matSuffix>search</mat-icon>
                <input matInput placeholder="{{'Search Agent' | translate}}" />
            </mat-form-field>

            <div class="checkbox-list d-flex flex-column">
                <mat-checkbox *ngFor="let opt of dialogOptions; trackBy: trackById" [(ngModel)]="opt.selected"
                    (change)="onCheckboxChange(opt)">
                    <strong>{{ opt.id }}</strong> &nbsp;{{ opt.name }}
                </mat-checkbox>
            </div>
        </ng-template>
    </mat-dialog-content>

    <mat-dialog-actions class="bulk-action">
        <button class="btn save-modal-btn"
            [disabled]="isDialogConfirmDisabled"
            (click)="onDialogConfirm()">{{'Confirm' | translate}}</button>
        <button class="btn cancel-modal-btn" (click)="onDialogCancel()">{{'Cancel' | translate}}</button>
    </mat-dialog-actions>
</ng-template>
